<template>
  <div class="template-wrap month-event-template" v-bind:class="computedClass">
    <div class="subject">
      <span>{{ data.subject }}</span>
      <span>
        {{ data.FriendlyStatus }}
      </span>
    </div>
    <div class="description">
      <span>{{ data.ProductCode }}</span>
      <GcCommentIcon v-if="data.HasNote === 'Y'" class="calendar-comment" />
    </div>
  </div>
</template>

<script>
import { formatNumber } from "devextreme/localization";
import GcCommentIcon from "../gc-comment-icon.vue";
export default {
  components: { GcCommentIcon },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
  },
  computed: {
    computedClass() {
      const status = this.data.FriendlyStatus
        ? this.data.FriendlyStatus.toFriendlyStatus()
        : false;
      return {
        active: status === "Active",
        inproduction: status === "In Production",
        completed: status === "Completed",
        cancelled: status === "Cancelled",
        draft: status === "Draft",
      };
    },
  },
};
</script>

<style lang="scss">
.e-appointment,
.e-appointment-details {
  .active {
    background: #62d26f;
  }

  .inproduction {
    background-color: #ffa500;
  }

  .completed {
    background-color: #4186e0;
  }

  .cancelled {
    background-color: #e8384f;
  }

  .draft {
    background-color: #eec300;
  }

  .month-event-template {
    padding: 5px 5px;
    width: 100%;
    .subject {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
    }

    .subject span:last-child {
      font-size: 10px;
    }

    .description {
      font-size: 12px;

      display: inline-flex;
      justify-content: space-between;
      width: 100%;
    }
  }
}
</style>
